
/*

 Textfields (with reset icon, adaptive placeholders etc)

 */

function textfield_init($o, context)
{
    if (typeof $o === "undefined") $o = $(".textfield");

    if (!$("body").hasClass("textfield-inited")) {

        $(document).on("keydown keyup focus blur textfield-filled", ".textfield", function (e) {
            var is_filled = !!$(this).val();
            // if (e.type === "textfield-filled") { // remove inline attribute value for CSS [value] selector purpose
            //     if ($(this).val().length) $(this).prop("value", $(this).val());
            //     $(this).removeAttr("value");
            // }
            $(this).toggleClass("filled", is_filled);
        });
        // $(document).ajaxStop(function() {
        //     setTimeout(function(){
        //         $(".textfield").trigger("textfield-filled");
        //     }, 50);
        // });

        $("body").addClass("textfield-inited")
    }
    if (!$o) {
        $o = context?$('.textfield', context):$('.textfield');
    }
    $o.trigger("textfield-filled");
}


/*

Custom Checkboxes

 */

function checkbox_plain_init($o, context) {
    if (!$o) {
        $o = context?$('.checkbox-plain-js', context):$('.checkbox-plain-js');
    }
    $o = $o.not(".checkbox-plain-js-inited");
    $o.find("[type='checkbox'], [type='radio']").on("change change-pseudo", function(e){
        var $o = $(this).closest(".checkbox-plain-js");
        var name = $(this).attr("name");
        if ($(this).prop("type") == 'radio') {
            var $radios = $(this).closest("form").find("[name='"+name+"']");
            if (!$radios.length) $radios = $("input[name='"+name+"']");
            $radios = $radios.not(':checked');
            $radios.closest(".checkbox-plain-js").removeClass("checked");
        }
        if ($(this).prop("checked")) $o.addClass("checked");
        else $o.removeClass("checked");
        if ($(this).prop("disabled")) $o.addClass("disabled");
        else $o.removeClass("disabled");
    }).on("focus", function(e){
        var $o = $(this).closest(".checkbox-plain-js");
        if (!$(this).prop("disabled")) $o.addClass("focused");
    }).on("blur", function(e){
        var $o = $(this).closest(".checkbox-plain-js");
        $o.removeClass("focused");
    }).on('click', function(e){
        var $input = $(this).data("uncheckable");
        if (typeof $(this).data("uncheckable") !== 'undefined') {
            var previousValue = $(this).attr('data-previousValue');
            var name = $(this).attr('name');
            var $radios = $(this).closest("form").find("[name='"+name+"']");
            if (!$radios.length) $radios = $("input[name='"+name+"']");
            if (previousValue == 'checked') {
                $(this).prop('checked', false).trigger('change');
                $(this).attr('data-previousValue', false);
            } else {
                $radios.attr('data-previousValue', false);
                $(this).attr('data-previousValue', 'checked');
            }
        }
    }).each(function(){
        var $o = $(this).closest(".checkbox-plain-js");
        if ($(this).attr("checked")) $o.addClass("checked");//?? prop
        if ($(this).attr("disabled")) $o.addClass("disabled");//?? prop
    });
    $o.addClass("checkbox-plain-js-inited");
}
